import { collection, getDocs, onSnapshot } from "firebase/firestore";
import React, { Component, Suspense } from "react";
import { db } from "../../component/firebase";
import "../../assets/css/Access.css"
// Importing Section
const Navbar = React.lazy(() => import("../../component/Navbar/NavBar"));

const Section = React.lazy(() => import("./Section"));
const About = React.lazy(() => import("../../component/About"));
const Services = React.lazy(() => import("../../component/Services"));
const Features = React.lazy(() => import("../../component/Features"));
const Pricing = React.lazy(() => import("../../component/Pricing"));
const Clients = React.lazy(() => import("../../component/Clients"));
const Blog = React.lazy(() => import("../../component/Blog"));
const Contact = React.lazy(() => import("../../component/Contact"));
const Footer = React.lazy(() => import("../../component/Footer/Footer"));

// import { Spinner } from "reactstrap";

class Layout_1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users:[],
      link:"",
      navItems: [
        { id: 1, idnm: "home", navheading: "Home" },
        { id: 2, idnm: "about", navheading: "About" },
        { id: 3, idnm: "services", navheading: "Services" },
        { id: 4, idnm: "features", navheading: "Features" },
        { id: 5, idnm: "clients", navheading: "Clients" }, 
        { id: 6, idnm: "contact", navheading: "Contact Us" },
        // { id: 6, idnm: "Admin", navheading: "Admin" }
        // { id: 5, idnm: "pricing", navheading: "Pricing" },
        // { id: 6, idnm: "blog", navheading: "Blog" },
      ],
      pos: document.documentElement.scrollTop,
      imglight: true,
      navClass: "navbar-light navbar-custom sticky sticky-dark",
    };
  }
  fetchMessages = () => {
        
    const unsub = onSnapshot(collection(db, "employes"), (snapshot) => {
        let list = [];
        snapshot.docs.forEach((doc) => {
            list.push({ id: doc.id, ...doc.data() })
        });
        //  console.log(list)
        this.state.users = list
        //  console.log("dd",this.state.users)
        // setLoading(false);
    }, (errors) => {
        console.log(errors);
    })
    
    return () => {

        console.log("ddd")
        unsub();
        
    }
}
fetchLinks = async () => {
  try {
    const linksRef = collection(db, "links");
    const snapshot = await getDocs(linksRef);

    if (!snapshot.empty) {
      const firstDocument = snapshot.docs[0];
      const linkData = firstDocument.data();
      this.setState({ link: linkData.link });
      console.log(this.state.link)
    }
  } catch (error) {
    console.log(error);
  }
};
  componentDidMount() {
    console.log("fewf")
    this.fetchLinks();
    this.fetchMessages();
    window.addEventListener("scroll", this.scrollNavigation, true);
    
    
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.scrollNavigation, true);
  }

  scrollNavigation = () => {
    var scrollup = document.documentElement.scrollTop;
    if (scrollup > this.state.pos) {
      this.setState({ navClass: "nav-sticky navbar-light navbar-custom sticky sticky-dark", imglight: false });
    } else {
      this.setState({ navClass: "navbar-light navbar-custom sticky sticky-dark", imglight: true });
    }
  };

  //set preloader div
  PreLoader = () => {
    return (
      <div id="preloader">
        <div id="status">
          <div className="sk-cube-grid">
            <div className="sk-cube sk-cube1"></div>
            <div className="sk-cube sk-cube2"></div>
            <div className="sk-cube sk-cube3"></div>
            <div className="sk-cube sk-cube4"></div>
            <div className="sk-cube sk-cube5"></div>
            <div className="sk-cube sk-cube6"></div>
            {/* <div className="sk-cube sk-cube7"></div> */}
            {/* <div className="sk-cube sk-cube8"></div>
            <div className="sk-cube sk-cube9"></div> */}
          </div>
        </div>
      </div>
    );
  };

  render() {
    return (
      <React.Fragment>
        <Suspense fallback={this.PreLoader()}>
          {/* Importing Navbar */}
          <Navbar
            navItems={this.state.navItems}
            navClass={this.state.navClass}
            imglight={this.state.imglight}
          />

          {/* Importing Section */}
          <Section />
          {/* {this.state.link} */}
          {/* Importing About */}
{     this.state.link &&     <marquee style={{"fontSize":"30px","fontWeight":"500"}} className="blinking-text"><span><a href={this.state.link}>Go to Link</a></span></marquee>
}          <About users={this.state.users}/>

          {/* Importing Services */}
          <Services />

          {/* Importing Features */}
          <Features />

          {/* Importing Pricing */}
          {/* <Pricing /> */}

          {/* Importing Clients */}
          <Clients />

          {/* Importing Blog */}
          {/* <Blog /> */}

          {/* Importing Contact */}
          <Contact />

        {/* Importing Footer */}
          <Footer />

        </Suspense>
      </React.Fragment>
    );
  }
}
export default Layout_1;
